<template>
    <v-container>
        <v-dialog v-model="dialog" max-width="1240px" persistent>
            <template v-slot:activator="{ on, attrs }">
                <v-icon
                        small
                        class="mr-2"
                        v-bind="attrs"
                         v-on="on"
                    >edit
                </v-icon>
            </template>
            <v-card>
                <v-card-title>ข้อมูลใบแจ้งหนี้ ของใบประเมิน : {{data.estimateNo}}</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-row class="justify-center">
                        <v-col cols="12">
                            <v-card>
                                <v-data-table
                                    :headers="invoiceHeader"
                                    :items="invoiceData"
                                >
                                <template v-slot:top >
                                    <v-toolbar flat color="white">
                                            รายการใบแจ้งหนี้
                                            <v-spacer></v-spacer>
                                            <v-dialog v-model="dialogInvoice"  persistent max-width="800px">
                                                <template  v-slot:activator="{ on }">
                                                    <v-btn color="primary" dark class="mb-2" v-on="on">เพิ่ม</v-btn>
                                                </template>

                                                <v-card>
                                                    <v-card-title>เพิ่ม / แก้ไขใบแจ้งหนี้</v-card-title>
                                                    <v-divider></v-divider>
                                                    <v-card-text>
                                                        <v-form ref="formInvoice" lazy-validation>
                                                            <v-row>
                                                                <v-col cols="3">
                                                                    <DatePicker 
                                                                        ref="invoiceDate"
                                                                        label="วันที่ใบแจ้งหนี้" 
                                                                        @dateFormatted="setInvoiceDate" >
                                                                    </DatePicker>
                                                                </v-col>
                                                                <v-col  cols="3">
                                                                    <v-text-field 
                                                                        label="เลขที่ใบแจ้งหนี้"
                                                                        autofocus
                                                                        :disabled="editedIndex >= 0"
                                                                        placeholder=" "
                                                                        :rules="[rules.required, chkCode]" 
                                                                        outlined
                                                                        v-model="item.invoiceNo">
                                                                    </v-text-field>
                                                                </v-col>
                                                                <v-col  cols="3">
                                                                    <v-text-field
                                                                        label="ยอดใบแจ้งหนี้"
                                                                        placeholder=" "
                                                                        outlined
                                                                        :rules="[rules.requiredNumber]" 
                                                                        v-model="item.invoiceAmount">
                                                                    </v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row>
                                                                <v-col>
                                                                    <v-textarea outlined label="หมายเหตุ" v-model="item.remark"></v-textarea>
                                                                </v-col>
                                                            </v-row>
                                                        </v-form>
                                                    </v-card-text>
                                                    <v-divider></v-divider>
                                                    <v-card-actions class="text-right">
                                                        <v-spacer></v-spacer>
                                                        <v-btn color="primary" @click="saveInvoice">บันทึก</v-btn>
                                                        <v-btn color="primary" @click="closeDialogInvoice"> ยกเลิก</v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                    </v-toolbar>
                                    <v-divider class="mx-4"></v-divider>
                                </template>
                                <template v-slot:item.action="{ item }">
                                    <v-icon
                                        small
                                        @click="editItem(item)"
                                    >
                                        edit
                                    </v-icon>
                                    <v-icon
                                        small
                                        @click="deleteItem(item)"
                                    >
                                        delete
                                    </v-icon>
                                </template>
                                </v-data-table>
                            </v-card>
                             
                        </v-col>
                    </v-row>

                    <v-row class="justify-center">
                        <v-col cols="12">
                            <v-card>
                                <v-card-subtitle>รายละเอียดงานซ่อม</v-card-subtitle>
                                <v-divider class="mx-4"></v-divider>
                                <v-data-table
                                    :headers="detailsHeader"
                                    :items="details"
                                >
                                </v-data-table>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
                
                <v-card-actions class="text-right">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="save">บันทึก</v-btn>
                    <v-btn color="primary" @click="closeDialog"> ยกเลิก</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import DatePicker from '@/components/Shared/DatePicker'
import rules from '@/assets/js/rules.js'
import {listBpeService, listBpeInvoice, saveJobInvoice, existInvoiceNo} from '@/api/job/job-invoice-api.js'
import numeral from 'numeral'
import dialog from '@/assets/js/dialog.js'
import moment from 'moment'

export default {
    name: 'JobInvoice',
    components: {
        DatePicker
    },
    computed: {
        chkCode() {
            if (this.editedIndex < 0 &&this.isDup == true) return 'เลขที่ใบสั่งซ่อมซ้ำ';
            return true;
        },
        invoiceData() {
            return this.invoiceItems.filter(o => o.deleted == undefined || o.deleted == false);
        }
    },
    props: ["data"],
    watch: {
        'item.invoiceNo': function(newVal) {
            console.log(this.invoiceItems.filter(o => o.invoiceNo == newVal).length);
            if (this.invoiceItems.filter(o => o.invoiceNo == newVal).length > 0) {
                this.isDup = true;
                return;
            }
            existInvoiceNo(this.data.branchCode, newVal).then(response => {
                    this.isDup = response;
                }).catch(() => {
                    this.isDup = false;
                });
        },
        dialogInvoice(val) {
            if (val) {
                let newDate = '';
                if (this.editedIndex >= 0) {
                    newDate = moment(this.item.invoiceDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
                } else {
                    newDate = new Date().toISOString().substr(0, 10);
                }
                this.$nextTick(() => {
                    this.$refs.invoiceDate.setDate(newDate);
                });
                
            }
        },
        dialog(val) {
            if (val) {
                listBpeInvoice(this.data.estimateId).then(rs => {
                    this.invoiceItems = rs;
                    this.invoiceItems.forEach(o => {
                        o.jobNo = this.data.jobNo;
                        o.branchCode = this.data.branchCode;
                        o.invoiceAmountDisplay = numeral(o.invoiceAmount).format('0,0.00');
                    });
                });
                listBpeService(this.data.estimateId).then(rs => {
                    this.details = rs;
                    if (this.details && this.details.length > 0) {
                        this.details.forEach(o => {
                            this.setDisplay(o);
                            o.jobNo = this.data.jobNo;
                            o.branchCode = this.data.branchCode;
                        });
                    }
                });
            }
        }
    },
    data: () => ({
        isDup: false,
        rules: rules,
        dialog: false,
        dialogInvoice: false,
        detailsHeader: [
            {text: 'รหัสงานซ่อม', value: 'serviceCode'},
            {text: 'รายการซ่อม', value: 'serviceName'},
            {text: 'จำนวน', value: 'qty', align: 'right'},
            {text: 'ราคา/หน่วย', value: 'unitPriceDisplay', align: 'right'},
            {text: 'ยอดรวม', value: 'totalDisplay', align: 'right'},
            {text: 'ส่วนลด(%)', value: 'discountPercentDisplay', align: 'right'},
            {text: 'รวมสุทธิ', value: 'grandTotalDisplay', align: 'right'},
        ],
        invoiceHeader: [
            {text: 'วันที่ใบแจ้งหนี้', value: 'invoiceDate'},
            {text: 'เลขที่ใบแจ้งหนี้', value: 'invoiceNo'},
            {text: 'ยอดใบแจ้งหนี้', value: 'invoiceAmountDisplay'},
            {text: 'Actions', value: 'action', sortable: false, align: 'center'}
        ],
        details: [],
        invoiceItems: [],
        item: {
            invoiceDate: '',
            invoiceNo: '',
            invoiceAmount: '',
            invoiceAmountDisplay: '',
            deleted: false,
            remark: '',
            jobNo: '',
            branchCode: ''
        },
        defaultItem: {
            invoiceDate: '',
            invoiceNo: '',
            invoiceAmount: '',
            invoiceAmountDisplay: '',
            deleted: false,
            remark: '',
            jobNo: '',
            branchCode: ''
        },
        editedIndex: -1
    }),
    methods: {
        setDisplay(obj) {
            obj.discountPercentDisplay = numeral(obj.discountPercent).format('0,0.00');
            obj.totalDisplay = numeral(obj.total).format('0,0.00');
            obj.discountPriceDisplay = numeral(obj.discountPrice).format('0,0.00');
            obj.grandTotalDisplay = numeral(obj.grandTotal).format('0,0.00');
            obj.unitPriceDisplay = numeral(obj.unitPrice).format('0,0.00');
        },
        setInvoiceDate(val) {
            this.item.invoiceDate = val;
        },
        save() {
            /*
            if (this.invoiceItems == undefined || this.invoiceItems.filter(o => !o.deleted).length == 0) {
                dialog.warn("กรุณาเพิ่มข้อมูลใบแจ้งหนี้");
                return;
            }
            */
            saveJobInvoice(this.invoiceItems).then(() => {
                dialog.info("บันทึกข้อมูลสำเร็จ");
                this.closeDialog();
            });
        },
        editItem(item) {
            this.editedIndex = this.invoiceItems.indexOf(item);
            this.item = Object.assign(this.defaultItem, item);
            this.item.invoiceDate = item.invoiceDate;
            this.dialogInvoice = true;
        },
        deleteItem(item) {
            if (!confirm("คุณต้องการลบข้อมูลใช่หรือไม่ ?")) {
                return
            }
            const index = this.invoiceItems.indexOf(item);
            item.deleted = true;
            this.invoiceItems.splice(index, 1);
            this.invoiceItems.push(item);
        },
        saveInvoice() {
            if (!this.$refs.formInvoice.validate()) {
                return;
            }
            this.item.invoiceAmountDisplay = numeral(this.item.invoiceAmount).format('0,0.00');
            if (this.editedIndex >= 0) {
                Object.assign(this.invoiceItems[this.editedIndex], this.item);
            } else {
                this.item.estimateId = this.data.estimateId;
                this.item.jobNo = this.data.jobNo;
                this.item.branchCode = this.data.branchCode;
                this.invoiceItems.push(this.item);
            }

            this.closeDialogInvoice();
        },
        closeDialog() {
            this.dialog = false;
        },
        closeDialogInvoice() {
            this.dialogInvoice = false;
            this.$nextTick(() => {
                 this.item = Object.assign({}, {});
                 this.editedIndex = -1;
                 this.$refs.invoiceDate.resetDate();
            })
        }
    }
}
</script>